import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { Observable } from 'rxjs';
import { StrategicKpi } from '../models/treeModels/strategicKpi';
import { Vision } from '../models/treeModels/vision';
import { VisionKpi } from '../models/treeModels/visionKpi';
import { Constants } from 'src/@smartmanufacturing/common/constants';


@Injectable({
  providedIn: 'root',
})
export class KpitargetService {
  
  get NetApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  addTarget(data: any): any {

    return this.http.post<any>(this.NetApiUrl + 'KPITargets/AddKpiTargets', data);
  }
  updateKpi(data: any): any {

    return this.http.put<any>(this.NetApiUrl + 'KPITargets/UpdateKpiTarget', data);
  }
  DeleteTarget(data:any):any {
    return this.http.post<any>(this.NetApiUrl + 'KPITargets/DeleteKpiTarget', data);
  }
  //NOT IN USE
  // deleteKpi(id: any): any {

  //   return this.http.delete<any>(this.baseUrl + 'kpitree/' + id);
  // }

  getTarget(data: any): any {

    return this.http.post<any>(this.NetApiUrl + 'KPITargets/GetKpiTarget', data);
  }

  getVisions(): Observable<Vision[]> {

    // return this.http.get<Vision[]>(this.baseUrl + 'visions');
    return this.http.get<Vision[]>(this.NetApiUrl + 'Vision/GetAllVisions');
  }

  //NOT IN USE
  // getOneVision(id: any): Observable<VisionKpi> {

  //   return this.http.get<VisionKpi>(this.baseUrl + 'vision/' + id);
  // }

  //NOT IN USE
  // updateVision(id: number, data: any): any {

  //   return this.http.put<any>(this.baseUrl + 'vision/' + id, data);
  // }

  getZeroValueTarget(data: any): any {

    return this.http.post<any>(this.NetApiUrl + 'KPITargets/GetZeroValue', data);
  }

  //NOT IN USE
  // deleteTarget(data: any): any {

  //   return this.http.post<any>(this.baseUrl + 'deleteTarget', data);
  // }

  deleteKpiTarget(data: any): any {

    return this.http.post<any>(this.NetApiUrl + 'KPI/DeleteWholeKPis', data);
  }
  refreshKpiTarget(data: any): any {

    return this.http.post<any>(this.NetApiUrl + 'KPITargets/RefreshKpis', data);
  }

  //NOT IN USE
  // addStrategicKpi(data: any): any {

  //   return this.http.post<any>(this.baseUrl + 'strategickpi', data);
  // }

  //NOT IN USE
  // getOneStrategicKpi(id: any): Observable<StrategicKpi> {

  //   return this.http.get<StrategicKpi>(this.baseUrl + 'strategickpi/' + id);
  // }

  //NOT IN USE
  // updateStrategicKpi(data: any): any {

  //   return this.http.put<any>(this.baseUrl + 'strategickpi', data);
  // }

  //NOT IN USE
  // deleteStrategicKpi(id: any): any {

  //   return this.http.delete<any>(this.baseUrl + 'strategickpi/' + id);
  // }

  getTreeData(data: any): Observable<any[]> {

    return this.http.get<TreeNode[]>(this.NetApiUrl + 'KPITree/GetKpiTrees' + data);
  }

  //NOT IN USE
  // getKpiByID(id: any): Observable<any> {

  //   return this.http.get<any>(this.baseUrl + 'kpitree/' + id);
  // }

  getTargets(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.NetApiUrl + 'KPI/GetTargetData', data);
  }
}
